module.exports = __webpack_public_path__ + "a626da0cf4f4925d05b6745ee0c6039b.pdf";